import TYPES from '@/modules/shared/types';

// Domain
import {
  GroupRepository,
} from '../../domain/repository/group-repository';
import {
  CustomerGroupDto,
} from '../../domain/dtos/customer-group-dto';
import {
  GroupEntity,
} from '../../domain/entities/group-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import { HttpConnector } from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class GroupHttpRepository implements GroupRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly base_url = `${process.env.VUE_APP_API_URL}/api/v1/app/group/`;

  get_customer_group_id(payload: CustomerGroupDto): Promise<GroupEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(`${this.base_url}customer/`, 'POST', payload)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(JSON.stringify({
                  status_code: response.status,
                  message_error: message,
                }));
              }
            });
        })
        .catch(reject);
    });
  }
}
